export const CALC_TOTAL_TIME = 'TIMERS_TYPE__CALC_TOTAL_TIME';
export const DROP_TIMER = 'TIMERS_TYPE__DROP_TIMERS';
